define(function() {
  var nativeJSON = null;

  try {
    var iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    nativeJSON = iframe.contentWindow.JSON;
    // IE requires that we "leak" this iframe to keep the script executable
    //iframe.parentNode.removeChild(iframe);
  } catch (e) {
  }

  return nativeJSON || JSON;
});
